import app from './app.json';
import component from './component.json';
import error from './error.json';
import page from './page.json';
import schema from './schema.json';

export default {
  app,
  component,
  error,
  page,
  schema,
};
